import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import Card from 'zignal-landscape/lib/Card';
import isEmpty from 'lodash/isEmpty';

import {
  getIcon,
  getHomeCardClasses
} from '../../homePageHelper';

import { RightOutlined } from '@ant-design/icons';

const HomeCard = ({ styles, cardProps, extendHeight, extendWidth }) => {
  const classes = getHomeCardClasses(styles, extendHeight, extendWidth);
  const {
    label,
    description,
    items,
    bottom,
    type
  } = cardProps;

  const isBottomDisplay = isEmpty(items) || (items?.length === 1 && items[0]?.type === 'default');

  return (
    <div className={classes.wrapperClass}>
      <Card>
        <div className={classes.containerClass}>
          <h3 className={styles.CardTitle}>
            {label}
          </h3>
          {
            ((type === 'Alert Rules' || type === 'Dashboards' || type === 'Reports') && isEmpty(items)) && (
              <div className={styles.CardDescription}>
                {`You haven't created any ${type} yet!`}
              </div>
            )
          }
          {
            (<div>
              <ul>
                {
                  items && items.map((item, i) => {
                    return (
                      <li key={i} className={styles.CardItem} data-cy={`${label}-list`}>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            window.AppRouter.navigate(item.url,{trigger: true});
                          }}
                        >
                          {item.label}
                        </a>
                      </li>
                    );
                  })
                }
              </ul>
              {
                isBottomDisplay &&
                (
                  <div className={styles.CardBottom}>
                    <a href={bottom.link} target="_blank">
                      {bottom.label}<RightOutlined className={styles.CardIconBottom} />
                    </a>
                  </div>
                )
              }
            </div>)
          }
        </div>
      </Card>
    </div>
  );
};

HomeCard.propTypes = {
  styles: PropTypes.object.isRequired,
  cardProps: PropTypes.object.isRequired,
  extendHeight: PropTypes.bool,
  extendWidth: PropTypes.bool
};

export default themeable(HomeCard);
